import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=445330e0"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports